import React, { useEffect, useState } from 'react'

import { Icon } from '../../components/Icon'
import {
  // IncidentsDummyData,

  policyHeader,
  SchoolsHeaders,
} from '../../data/index'
import Menu from '../../components/UI/UIMenu'

import UISubHeaderComponent from '../../components/UI/UISubHeaderComponent'
import Pagination from '../../components/UI/Pagination'
import '../../App.css'
import { useQuery } from 'react-query'
import {
  getSuperSchoolFeatures,
  getSuperScoolData,
  getSuperScoolGroupData,
  schoolData,
} from './apiCall'
import {
  approveAndRejectSchool,
  createSchoolApi,
  createSchoolType,
  deleteSchool,
  updateSchoolApi,
  updateSchoolFeatures,
  updateSchoolRoleApi,
} from '../../api/super/schools'
import { toast } from 'react-toastify'
import { calculatePageCount } from '../training/utils'
import Modal from '../../components/UI/UIModal'
import UITextInput from '../../components/UI/UITextInput'
import UIButton from '../../components/UI/UIButton'
import Loading from '../../components/UI/Loading'
import UiSelect from '../../components/UI/UISelect'
import { ErrorResponse, incidentData, User } from '../../utils/types'
import { removeNullEntries } from '../../utils/utils'
import UISwitch from '../../components/UI/UISwitch'

interface schoolDataInterface {
  name: string
  addressLineOne: string
  addressLineTwo: string
  logo?: string
  groupId?: string
  brandConfig: {
    colors: string
    fonts: string
  }
}

const initialData = {
  name: '',
  addressLineOne: '',
  addressLineTwo: '',
  brandConfig: {
    colors: 'red',
    fonts: 'test',
  },
}
const Schools = () => {
  const [isView, setIsView] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [schoolData, setSchoolData] = useState<schoolDataInterface>(initialData)
  const [isEdit, setIsEdit] = useState(false)
  const [schoolId, setSchoolId] = useState('')
  const [isOpenDelete, setIsOpenDelete] = useState(false)
  const [isOpenPrmotoionModal, setIsOpenPrmotoionModal] = useState(false)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [role, setRole] = useState('')

  const [featureList, setFeatureList] = useState([
    { title: 'Home', isAvilable: true, isVisible: false },
    { title: 'SCR', isAvilable: true, isVisible: true },
    { title: 'Policy', isAvilable: true, isVisible: true },
    { title: 'Meetings', isAvilable: true, isVisible: true },
    { title: 'Incidents', isAvilable: true, isVisible: true },
    { title: 'Training Records', isAvilable: true, isVisible: true },
    { title: 'Whistle Blowing', isAvilable: true, isVisible: true },
    { title: 'Resources', isAvilable: true, isVisible: true },
  ])

  const handleRiskSwitchChange = (index: number, value: boolean) => {
    // Update the featureList based on the switch toggle
    const updatedFeatureList = featureList.map((feature, i) => ({
      ...feature,
      isAvilable: i === index ? value : feature.isAvilable, // Toggle the isAvilable value for the specific feature
    }))

    setFeatureList(updatedFeatureList) // Update the state with the new feature list
  }

  const getAvailableFeatures = (
    features: { title: string; isAvilable: boolean }[]
  ): string[] => {
    return features
      .filter((feature) => feature.isAvilable) // Filter features where isAvilable is true
      .map((feature) => feature.title) // Map to get the titles of the available features
  }

  const handleCloseModal = () => {
    setIsOpen(false)
  }
  const handleOpenModal = () => {
    setIsOpen(true)
  }
  const handleCloseDeleteModal = () => {
    setIsOpenDelete(false)
  }
  const handleClosePromotionModal = () => {
    setIsOpenPrmotoionModal(false)
  }

  const handleChange = (fieldName: string, value: string): void => {
    setSchoolData((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }))
  }

  const handlePageChange = (pageNumber: number): void => {
    setCurrentPage(pageNumber)
    // You can add additional logic here, like fetching data for the new page
  }

  const getSchools = useQuery('schools', () => getSuperScoolData(currentPage))
  const getGroupSchools = useQuery('groups', () => getSuperScoolGroupData())

  const getSchoolFeatures = useQuery(
    'schoolFeatures',
    () => getSuperSchoolFeatures(schoolId),
    {
      enabled: !!schoolId,
    }
  )

  const updatedFeatureList = featureList.map((feature) => ({
    ...feature,
    isAvilable:
      getSchoolFeatures?.data?.data?.features?.permissions?.includes(
        feature.title
      ) || false,
  }))

  useEffect(() => {
    setFeatureList(updatedFeatureList)
  }, [getSchoolFeatures?.data?.data?.features?.permissions])

  const [isOpenMenu, setIsOpenMenu] = useState<boolean[]>(
    new Array(Number(getSchools.data?.count) || 100).fill(false)
  )
  const handleToggleMenu = (rowIndex: number | null) => {
    const updatedMenuState = isOpenMenu.map((isOpen: unknown, index: number) =>
      index === rowIndex ? !isOpen : false
    )
    setIsOpenMenu(updatedMenuState)
  }
  const actionSchoolVerification = async (
    verification: string,
    id: string
  ): Promise<void> => {
    const response = (await approveAndRejectSchool(verification, id)) as {
      status?: string
      data: schoolData
    }
    if (response?.status == 'successful') {
      getSchools.refetch()
      toast.success('done.', {
        position: 'top-right',
      })
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  const statusBgColor = (status: string): string => {
    switch (status) {
      case 'Completed':
        return 'lightGreen'
      case 'Lapsed':
        return 'paleYellow'
      case 'Failed':
        return 'palePink'
      default:
        return 'gray3'
    }
  }
  //   const statusBgColor = (status: string): string => {
  //     switch (status) {
  //       case 'Published':
  //         return 'lightGreen'
  //       case 'Lapsed':
  //         return 'paleYellow'
  //       case 'Not Active':
  //         return 'palePink'
  //       default:
  //         return 'gray3'
  //     }
  //   }

  console.log(getSchools)

  const createSchool = async (): Promise<void> => {
    try {
      const response = (await createSchoolApi(schoolData)) as {
        status?: string
        data: schoolData
      }
      if (response?.status == 'successful') {
        getSchools.refetch()
        handleCloseModal()
        setSchoolData(initialData)
        toast.success('School Created.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }
  const editSchool = async (): Promise<void> => {
    try {
      const response = (await updateSchoolApi(
        removeNullEntries(schoolData) as createSchoolType,
        schoolId
      )) as {
        status?: string
        data: User
      }
      if (response?.status == 'successful') {
        setIsEdit(false)
        setSchoolData(initialData)
        getSchools.refetch()
        handleCloseModal()
        setIsView(false)

        toast.success('Group Updated.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }

  const editSchoolFeature = async (): Promise<void> => {
    try {
      const response = (await updateSchoolFeatures(
        getAvailableFeatures(featureList),
        schoolId
      )) as {
        status?: string
        data: User
      }
      if (response?.status == 'successful') {
        setIsEdit(false)
        setSchoolData(initialData)
        getSchools.refetch()
        getSchoolFeatures.refetch()
        handleCloseModal()
        setIsView(false)

        toast.success('School Features Updated.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }
  const editSchoolRole = async (): Promise<void> => {
    try {
      const response = (await updateSchoolRoleApi(role, schoolId)) as {
        status?: string
        data: User
      }
      if (response?.status == 'successful') {
        setRole('')
        setIsOpenPrmotoionModal(false)
        getSchools.refetch()

        setIsView(false)

        toast.success('School Role Updated.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }
  const removeSchool = async (): Promise<void> => {
    try {
      const response = (await deleteSchool({ id: schoolId })) as {
        status?: string
        data: incidentData
      }
      if (response?.status == 'successful') {
        getSchools.refetch()
        setIsEdit(false)
        setIsView(false)
        setIsOpenDelete(!isOpenDelete)
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('An error occurred while deleting partner.', {
        position: 'top-right',
      })
    }
  }

  const convertedGroupData = getGroupSchools?.data?.data?.map((item) => ({
    value: item.id,
    label: item.name,
  }))
  useEffect(() => {
    getSchools.refetch()
  }, [currentPage])

  console.log(getSchoolFeatures?.data)

  return (
    <div
      className={
        'flex flex-col gap-20 w-full bg-white  h-full rounded-3xl p-5 '
      }
    >
      {!isView && (
        <div className="flex flex-col gap-10 w-full relative h-full">
          <div className={'flex w-full justify-between items-start '}>
            <div className="flex-col w-[50%] gap-[20px]">
              <p className={'text-[18px] text-text2 font-bold '}>Schools</p>
              {/* <p
                className={
                  'text-[14px] font-normal text-text1 leading-[24px] mt-2'
                }
              >
                Please add your incidents here. You can give various reasons and
                solutions, and specify their severity level.
              </p> */}
            </div>

            <div className={'flex flex-row gap-[15px]'}>
              {/* <div className=" gap-[10px] items-center justify-between min-w-[112px] bg-gray2 text-white h-12 px-[20px] flex rounded-[72px]   cursor-pointer ">
                <p className={'font-medium text-[14px] text-text1'}>
                  Export Data
                </p>
                <Icon
                  name={'exportIcon'}
                  strokeWidth={1}
                  stroke={'#02698C'}
                  width={16}
                  height={16}
                />
              </div> */}

              <div
                onClick={handleOpenModal}
                className="gap-[10px]  bg-bluishGreen items-center justify-between min-w-[95px] text-white h-12 px-[20px] flex rounded-[72px]   cursor-pointer "
              >
                <p className={'font-medium text-[14px] text-white'}>
                  Create School
                </p>
                <Icon
                  name={'IconPlus'}
                  strokeWidth={1}
                  stroke={'white'}
                  width={16}
                  height={16}
                />
              </div>
            </div>
          </div>

          {/* <div className="flex justify-center items-center self-start gap-[8px] ">
            <p className={'text-text2 font-semibold text-[14px] '}>Sort by</p>
            <div className="rounded-[72px] bg-gray2 w-[109px] h-[28px] flex justify-center items-center ">
              <p className={'text-text1 font-bold text-[12px]'}> last added</p>
            </div>
          </div> */}
          {/* content container */}
          {getSchools.isLoading && (
            <div className="flex justify-center items-center h-screen">
              <Loading size="medium" />
            </div>
          )}
          {!getSchools.isLoading && (
            <>
              <div
                id={'#container'}
                className="w-full flex justify-center items-center"
              >
                {/* table component */}

                <div className="overflow-hidden rounded-[16px] w-full">
                  <table className="rounded-[16px] overflow-hidden border w-full border-white">
                    <thead>
                      <tr className="bg-gray2 cursor-pointer">
                        {SchoolsHeaders?.map((item, index: number) => {
                          return (
                            <th
                              key={index}
                              className={`w-1/8 px-4 py-3 text-left ${policyHeader?.length - 1 === index ? 'border-0 border-gray2' : 'border border-white'}`}
                            >
                              <div className="flex items-center">
                                <p className="text-text1 font-semibold text-sm flex-1">
                                  {item.replace(/_/g, ' ')}
                                </p>
                                <div onClick={() => console.log('check')}>
                                  <Icon
                                    name={'IconChevronDown'}
                                    width={16}
                                    height={16}
                                    strokeWidth={1}
                                    stroke={'#67A5B9'}
                                  />
                                </div>
                              </div>
                            </th>
                          )
                        })}
                        <th className="w-1/8 px-4 py-3 border text-left border-white"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {getSchools?.data?.data?.map((item, index) => (
                        <>
                          <tr className="bg-gray1">
                            {/* Example row */}
                            <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              {item.no}
                            </td>
                            <td className="px-4  text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              {item.name}
                            </td>
                            <td className="px-4   text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              {item.schoolId}
                            </td>
                            <td className="px-4   text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              {item.groupName}
                            </td>
                            <td className="px-4   text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              {item.role}
                            </td>

                            <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              <div
                                className={`px-[10px] flex justify-center items-center bg-${statusBgColor(item.verificationStatus == null ? 'completed' : item.verificationStatus)} h-[28px] rounded-[100px]`}
                              >
                                <p className="text-xs font-medium leading-5 text-text2">
                                  {item.status == null
                                    ? 'completed'
                                    : item.status}
                                </p>
                              </div>
                            </td>
                            <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              <div
                                className={`px-[10px] flex justify-center items-center bg-${statusBgColor(item.verificationStatus == null ? 'completed' : item.verificationStatus)} h-[28px] rounded-[100px]`}
                              >
                                <p className="text-xs font-medium leading-5 text-text2">
                                  {item.verificationStatus == null
                                    ? 'completed'
                                    : item.verificationStatus}
                                </p>
                              </div>
                            </td>
                            <td className="px-4 w-[100px] text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              {item.createdBy}
                            </td>
                            <td className="px-4 w-[150px] text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              {item.createdAt?.substring(0, 16)}
                            </td>

                            {/* <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              {item.verificationStatus ==
                              'awaiting-verification' ? (
                                <div className="flex w-[50%] gap-[20px]">
                                  <div
                                    onClick={() => {
                                      actionSchoolVerification(
                                        'completed',
                                        item.id
                                      )
                                    }}
                                    className=" cursor-pointer px-[10px] flex justify-center items-center bg-lightGreen h-[28px] rounded-[100px]"
                                  >
                                    <p className="text-xs font-medium leading-5 text-text2">
                                      Approve
                                    </p>
                                  </div>
                                  <div
                                    onClick={() => {
                                      actionSchoolVerification(
                                        'failed',
                                        item.id
                                      )
                                    }}
                                    className=" cursor-pointer px-[10px] flex justify-center items-center bg-palePink h-[28px] rounded-[100px]"
                                  >
                                    <p className="text-xs font-medium leading-5 text-text2">
                                      Decline
                                    </p>
                                  </div>
                                </div>
                              ) : (
                                ''
                              )}
                            </td> */}

                            <td className="px-4 items-center justify-center flex   h-[48px] py-2 border border-white">
                              <Menu
                                isOpen={isOpenMenu[index]}
                                items={[
                                  {
                                    display:
                                      item.verificationStatus ==
                                      'Awaiting-Verification'
                                        ? true
                                        : false,
                                    label: 'Approve',
                                    onClick: () => {
                                      actionSchoolVerification(
                                        'Completed',
                                        item.id
                                      )
                                    },
                                    icon: 'IconEye',
                                    iconColor: 'lightGreen',
                                  },
                                  {
                                    display:
                                      item.verificationStatus ==
                                      'Awaiting-Verification'
                                        ? true
                                        : false,
                                    label: 'decline',
                                    onClick: () => {
                                      actionSchoolVerification(
                                        'Failed',
                                        item.id
                                      )
                                    },
                                    icon: 'IconEye',
                                    iconColor: 'palePink',
                                  },
                                  {
                                    label: 'View',
                                    onClick: () => {
                                      setIsView(true)
                                      // handleOpenModal()
                                      // setIsEdit(true)
                                      setSchoolId(item.id)
                                      setSchoolData({
                                        name: item.name,
                                        addressLineOne: item.addressLineOne,
                                        addressLineTwo: item.addressLineTwo,
                                        logo: item.logo,
                                        brandConfig: {
                                          colors: 'red',
                                          fonts: 'test',
                                        },
                                      })
                                      handleToggleMenu(index)
                                    },
                                    icon: 'IconEye',
                                    iconColor: '',
                                  },
                                  {
                                    label: 'Edit',
                                    onClick: () => {
                                      handleOpenModal()
                                      setIsEdit(true)
                                      setSchoolId(item.id)
                                      setSchoolData({
                                        name: item.name,
                                        addressLineOne: item.addressLineOne,
                                        addressLineTwo: item.addressLineTwo,
                                        logo: item.logo,
                                        brandConfig: {
                                          colors: 'red',
                                          fonts: 'test',
                                        },
                                      })
                                      handleToggleMenu(index)
                                    },
                                    icon: 'IconEdit',
                                    iconColor: '',
                                  },
                                  {
                                    label: 'Change Role',
                                    onClick: () => {
                                      setIsOpenPrmotoionModal(true)
                                      setRole(item.role)
                                      setSchoolId(item.id)
                                    },
                                    icon: 'IconFileMinus',
                                    iconColor: '',
                                  },
                                  {
                                    label: 'Remove',
                                    onClick: () => {
                                      setSchoolId(item.id)
                                      setIsOpenDelete(true)
                                    },
                                    icon: 'IconTrash',
                                    iconColor: '#FF6666',
                                    textColor: 'text-textError',
                                  },
                                ]}
                                type={'table'}
                                setIsOpenMenu={setIsOpenMenu}
                                isOpenMenus={isOpenMenu}
                              >
                                <div
                                  onClick={() => {
                                    // setSelectedItem(item)
                                    // setSelectedItemIndex(index)
                                    handleToggleMenu(index)
                                  }}
                                >
                                  <Icon
                                    name={'IconDotsVertical'}
                                    width={16}
                                    height={16}
                                    strokeWidth={1.5}
                                    stroke={'#02698C'}
                                  />
                                </div>
                              </Menu>
                            </td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}

          <div className="absolute bottom-4">
            {/* Your content here */}

            <Pagination
              currentPage={currentPage}
              totalPages={calculatePageCount(
                Number(getSchools?.data?.count) || 0
              )}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      )}
      {isView && (
        <div style={{ height: 'calc(100vh - 100px)', overflow: 'auto' }}>
          <UISubHeaderComponent
            onBack={() => {
              setIsView(false)
            }}
            mainPage="Schools"
            subPage={schoolData.name}
            copy="Here you can edit and manage the Schools"
            onCreate={() => {
              //   handleOpenModal()
              //   setIsEdit(false)
            }}
            // onPublish={}
            // onEdit={() => {
            //   //   handleOpenModal()
            //   //   setIsEdit(true)
            // }}
            // onDelete={() => {
            //   //   setIsOpenDelete(true)
            // }}
            isViewMode={true}
          />

          {/* content container */}

          <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Title
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {schoolData.name}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Address line 1
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {schoolData.addressLineOne}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Address line 2
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {schoolData.addressLineTwo}
                  </td>
                </tr>

                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>

          <p className={'text-text2 text-[14px] font-semibold'}>Features</p>
          <div className="flex-col w-[100%] justify-between">
            {featureList?.map((item, i) => (
              <div
                key={i}
                className={`w-full my-[5px] p-4 bg-gray1 rounded-xl flex ${item.isVisible ? 'visible' : 'hidden'}`}
              >
                <div className="flex-1">
                  <p className="text-sm font-semibold leading-6 text-text4">
                    {item.title}
                  </p>
                  {/* <p className="text-sm font-normal leading-6 text-text3">
                Can clients can access files in this sub category?
              </p> */}
                </div>
                <div>
                  <UISwitch
                    value={item.isAvilable}
                    onValueChange={(value) => handleRiskSwitchChange(i, value)}
                  />
                </div>
              </div>
            ))}
          </div>
          {/* modal */}
          <div className="w-[33%] mt-6">
            <UIButton onClick={editSchoolFeature} label="Update" />
          </div>
        </div>
      )}

      <Modal isOpen={isOpen} onClose={handleCloseModal}>
        <div
          className={
            'w-[480px] max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={handleCloseModal}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#02698C'}
              strokeWidth={0.5}
              height={56}
              width={56}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              {isEdit ? 'Update School' : 'Create School'}
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Please enter the details for school
            </p>
          </div>

          {/* other information */}
          <div className="w-[416px] flex-col flex gap-4 mt-[10px]">
            <div>
              <UITextInput
                label={'Name*'}
                onChange={(e) => {
                  handleChange('name', e.target.value)
                }}
                value={schoolData.name}
                placeholder="Please enter school name"
                iconName={''}
              />
            </div>
            <div>
              <UITextInput
                label={'Address 1'}
                onChange={(e) => {
                  handleChange('addressLineOne', e.target.value)
                }}
                value={schoolData.addressLineOne}
                placeholder="Please enter your address"
                iconName={''}
              />
            </div>
            <div>
              <UITextInput
                label={'Address 2'}
                onChange={(e) => {
                  handleChange('addressLineTwo', e.target.value)
                }}
                value={schoolData.addressLineTwo}
                placeholder="Please enter your address"
                iconName={''}
              />
            </div>
            <div>
              <UITextInput
                label={'Logo'}
                onChange={(e) => {
                  handleChange('logo', e.target.value)
                }}
                value={schoolData.logo}
                placeholder="Please add logo url"
                iconName={''}
              />
            </div>
            <div>
              <UiSelect
                options={convertedGroupData || []}
                title={'Select Group'}
                onChange={(e) => {
                  handleChange('groupId', e)
                }}
                value={schoolData.groupId}
              />
            </div>

            <UIButton
              onClick={isEdit ? editSchool : createSchool}
              type="submit"
              label={isEdit ? 'Update' : 'create'}
            />
          </div>
        </div>
      </Modal>
      <Modal
        customStyle={{ width: '480px', borderRadius: 16 }}
        isOpen={isOpenDelete}
        onClose={handleCloseDeleteModal}
      >
        <div
          className={
            'max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={handleCloseDeleteModal}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#FF6666'}
              strokeWidth={1}
              height={52}
              width={52}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              Delete School
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Are you sure you want to delete this School?
            </p>
          </div>

          <button
            onClick={() => {
              removeSchool()
              setIsView(false)
            }}
            className=" text-textError border-textError border-[1px] min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Yes, I am Sure
          </button>
          <button
            onClick={handleCloseDeleteModal}
            className=" text-text3 border-textError bg-gray2 min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Cancel
          </button>
        </div>
      </Modal>
      <Modal
        customStyle={{ width: '480px', borderRadius: 16 }}
        isOpen={isOpenPrmotoionModal}
        onClose={handleClosePromotionModal}
      >
        <div
          className={
            'max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={handleClosePromotionModal}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconFileMinus'}
              stroke={'#02698C'}
              strokeWidth={1}
              height={52}
              width={52}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>Change Role</h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Change role for school
            </p>
          </div>

          <div className="w-[100%]">
            <UiSelect
              options={[
                {
                  value: 'GROUP',
                  label: 'GROUP',
                },
                {
                  value: 'SCHOOL',
                  label: 'SCHOOL',
                },
              ]}
              title={'Select Role'}
              onChange={(e) => {
                setRole(e)
              }}
              value={role}
            />
          </div>

          <UIButton onClick={editSchoolRole} type="submit" label={'Update'} />
        </div>
      </Modal>
    </div>
  )
}

export default Schools
